/**
 * GuiaCliente — qué decirle al cliente y cuándo volver o ir al médico (2026-10-01).
 *
 * Sale de la guía clínica del motivo (data/clinico/sintomas_primera_linea.yaml, NICE/NHS/WHO),
 * no del modelo, y va una sola vez por motivo en el caso, con la primera recomendación.
 */
import { useState } from 'react'
import type { GuiaCliente as Guia } from '../types/sse'

/** Primera frase del consejo (Osvaldo 12-oct: "un texto más breve"; el resto en "ver más"). */
function primeraFrase(t: string): string {
  const m = t.match(/^.*?[.;](\s|$)/)
  return (m ? m[0] : t).trim()
}

export function GuiaCliente({ guia }: { guia: Guia }) {
  const [completo, setCompleto] = useState(false)
  if (!completo) {
    const alarma = guia.derivar_si.slice(0, 2).join('; ')
    return (
      <section className="guia-cliente guia-breve" aria-label="Para decirle al cliente">
        {guia.consejo && <p><span className="guia-label">Decile</span> {primeraFrase(guia.consejo)}</p>}
        {alarma && <p><span className="guia-label">Al médico si</span> {alarma}</p>}
        <button type="button" className="guia-ver-mas" onClick={() => setCompleto(true)}>ver más</button>
      </section>
    )
  }
  return (
    <section className="guia-cliente" aria-label="Para decirle al cliente">
      {guia.consejo && (
        <div className="guia-fila">
          <span className="guia-label">Decile al cliente</span>
          <p>{guia.consejo}</p>
        </div>
      )}
      {guia.derivar_si.length > 0 && (
        <div className="guia-fila">
          <span className="guia-label">Que vuelva o vaya al médico si</span>
          <ul>
            {guia.derivar_si.map((d) => (
              <li key={d}>{d}</li>
            ))}
          </ul>
        </div>
      )}
      {guia.fuente && (
        <span className="guia-fuente">
          {guia.source_url ? (
            <a href={guia.source_url} target="_blank" rel="noreferrer">{guia.fuente}</a>
          ) : (
            guia.fuente
          )}
        </span>
      )}
    </section>
  )
}
